<template lang="pug">

  apollo-query( v-bind:query="manyQuery" v-bind:tag="null" )

    template( v-slot="{ result: { loading: apolloLoading, error, data } }" )

      span( v-if="apolloLoading" ) Loading...

      span( v-else-if="data" )

        MLoadingSpinner( v-if="loading" class="ml-2 mr-1" )
        select(
          class="form-control w-auto inline mx-2"
          v-bind:value="object[childAccessor] && object[childAccessor].id"
          v-model="currentChild"
          v-on:change="update"
          v-bind:disabled="loading"
        )
          option(
            v-for="e in data[`${child}Many`]"
            v-bind:value="e.id"
          )
            slot( v-bind:child="e" )

</template>

<script>
import Vue from 'vue'
import gql from 'graphql-tag'
export default Vue.extend({
  
  props: {
    entity: {
      type: String,
      required: true
    },
    child: {
      type: String,
      required: true
    },
    childFields: {
      type: Array,
      required: true
    },
    object: {
      type: Object,
      required: true
    },
    objectChildField: {
      type: String
    },
    childSort: {
      type: String
    }
  },

  data() {
    return {
      childAccessor: this.objectChildField || this.child,
      currentChild:
        this.object &&
        this.object[(this.objectChildField && `${this.objectChildField}Id`) || this.child] &&
        this.object[(this.objectChildField && `${this.objectChildField}Id`) || this.child].id,
      loading: false,
    }
  },

  methods: {

    manyQuery(gql) {

      let queryParams = ''
      if (this.childSort) {
        queryParams = `(sort: ${this.childSort})`
      }

      return gql`query {
        ${this.child}Many${queryParams} {
          id
          ${this.childFields.join(' ')}
        }
      }`
    },

    async update() {
      
      this.loading = true

      const {
        data: {
          [`${this.entity}UpdateById`]: {
            [this.childAccessor]: updatedChild
          }
        }
      } = await this.$apollo.mutate({
        mutation: gql`mutation UpdateEntity($entityId: ID!, $childEntityId: ID!) {
          ${this.entity}UpdateById(
            id: $entityId
            record: {
              ${this.childAccessor}Id: $childEntityId
            }
          ) {
            id
            ${this.childAccessor} {
              ${this.childFields.join(' ')}
            }
          }
        }`,
        variables: {
          entityId: this.object.id,
          childEntityId: this.currentChild
        }
      })

      for (const [ key, value ] of Object.entries(updatedChild)) {
        if (! this.object[this.childAccessor]) this.object[this.childAccessor] = {}
        this.object[this.childAccessor][key] = value
      }

      this.loading = false
    }

  }

})
</script>